module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA8CAYAAABxVAqfAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEkSURBVHgB7ZiLCcIwEIYv0gG6gcUFdARHcARxAXEC3cARBBdxBTewG9gJPP+oSIU+7trUgN4HfwPtlY+UPi511BNmnmNYIGNkhqSvlMlL4xVZUUdZimyRK+u5IRlpwUnrjsK3mLS8ZtkXnTiQVCdG8ZLD8RA7gTTDcEIyCgM750YjQeE8oNRT+I1kxpfA4gtmPEmoWZp1lOYdj73FC9axR1ISkLQcn5GcAy7hRlosubkkMHLUnBBK7Ck0xT8hVmFiEw9Gws9mrY4xyZmyvJc6O/+Cpe/ifZNolzrKjKUdyCDEEBd/J6ZY4jyW+EFCzV1f1ZKzjpyeLwdXGqliX3vDgEd8J+wu1UtP+yya2MQmNrGJTWxiE5vYxCbW0/a/2sOBaj64AwCSA+zNaHDFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-fb.png
// module id = InwN
// module chunks = 1